import { ROUTES } from "@/lib/routes";

export const getScorekeepUrl = (
  machineId: string,
  eventType: string | null | undefined,
): string => {
  // Games use the V2 scorekeeper; other sessions stay on legacy tagging
  if (eventType === "game") {
    return `${ROUTES.TAGGING_V2}/${machineId}/game`;
  } else if (eventType === "batting_practice") {
    return `${ROUTES.TAGGING}/${machineId}/batting-practice`;
  } else if (eventType === "bullpen") {
    return `${ROUTES.TAGGING}/${machineId}/bullpen`;
  }

  return `${ROUTES.TAGGING}/${machineId}`;
};
